module.exports = __webpack_public_path__ + "img/pdf.7d9f1d12.png";